import React, {useState} from "react"
import {useCatalog, useSolution, useLocal} from "../../AppContext"
import {Apply} from "./Apply"
import {Button} from "../../Components/Button"
import style from "./ItemQuantity.css"

export const ItemQuantity = () => {
    const catalog = useCatalog()
    const solution = useSolution()
    const local = useLocal()
    const item = solution.getItem()
    const variant = catalog.getVariantProduct(item.parentSku, item.sku)
    const itemQty = item.elements.length
    const [qty, setQty] = useState(itemQty)
    const isMinQty = qty == itemQty

    let otherQty = 0;
    solution.getItems().map(itemLoop => {
        if(itemLoop.sku === item.sku && itemLoop.id !== item.id) {
            otherQty += item.elements.length
        }
    })

    const onAdd = () => {
        setQty(currentQty => currentQty + variant.unitCount)
    }

    const onSub = () => {
        if (!isMinQty) {
            setQty(currentQty => currentQty - variant.unitCount)
        }
    }

    const onApply = () => {
        solution.setItemQty(qty)
    }

    return <>
        <div>
            <div className={style.quantity}>
                <div>
                    <Button onClick={onSub} isDisabled={isMinQty}>-</Button>
                    <div className={style.display}>{otherQty + qty}</div>
                    <Button onClick={onAdd}>+</Button>
                </div>
                <div>
                    {local.__("Aus produktionstechnischen Gründen können Sie immer in %minQuantity%er Schriten weitere elemente hizufügen.", {minQuantity: variant.unitCount})}
                </div>
            </div>
        </div>
        <Apply onClick={onApply}/>
    </>
}